import { Text } from '@lili/lili-frontend-common';
import { FormProvider } from 'react-hook-form';
import { useTranslation, Trans } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper.tsx';
import { CustomRadioButton } from '@Pages/happyFlowPages/eddQuestions/components/SelectionGroup.tsx';
import { ControllerWrapper } from '@Hooks/index.ts';
import { useMonthlyPaymentVolumeLogic } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/monthly-payment-volume/useMonthlyPaymentVolumeLogic';
import { EddEmbeddedFields } from '../fields.types';

export const MonthlyPaymentVolume = () => {
  const {
    formMethods,
    monthlyVolumeOptions,
    monthlyTransactionsOptions,
    handleSubmit,
    isPostingEddData,
  } = useMonthlyPaymentVolumeLogic();

  const { t } = useTranslation();
  const { t: tCommon } = useTranslation();
  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isPostingEddData}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('monthlyPaymentVolume.title')}
        headingContainerCustomStyle='!mb-[24px]'>
        <div className='flex flex-col'>
          <Text.H9 className='mb-[16px]'>
            <Trans
              i18nKey={'monthlyPaymentVolume.groupATitle'}
              components={{ bold: <span className='font-semibold' /> }}
            />
          </Text.H9>
          <ControllerWrapper
            name={EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_TRANSACTIONS}
            control={formMethods.control}>
            {({ value, onChange }) => (
              <div className='flex flex-col gap-[12px] mb-[48px]'>
                {monthlyTransactionsOptions.map((option) => (
                  <CustomRadioButton
                    key={option.value}
                    onChange={() => onChange(option.value)}
                    checked={value === option.value}
                    inputId={option.value}
                    value={option.value}
                    name={EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_TRANSACTIONS}
                    label={option.label}
                  />
                ))}
              </div>
            )}
          </ControllerWrapper>

          <Text.H9 className='mb-[16px]'>
            <Trans
              i18nKey={'monthlyPaymentVolume.groupBTitle'}
              components={{ bold: <span className='font-semibold' /> }}
            />
          </Text.H9>
          <ControllerWrapper
            name={EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME}
            control={formMethods.control}>
            {({ value, onChange }) => (
              <div className='flex flex-col gap-[12px]'>
                {monthlyVolumeOptions.map((option) => (
                  <CustomRadioButton
                    key={option.value}
                    onChange={() => onChange(option.value)}
                    checked={value === option.value}
                    inputId={option.value}
                    value={option.value}
                    name={EddEmbeddedFields.EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME}
                    label={option.label}
                  />
                ))}
              </div>
            )}
          </ControllerWrapper>
        </div>
        <div className='flex flex-col gap-[16px] mt-[24px]'>
          <Text.H12 className='text-text-main-secondary'>
            {t('monthlyPaymentVolume.disclaimer')}
          </Text.H12>
        </div>
      </StepPageWrapper>
    </FormProvider>
  );
};
